import './scss/global.scss';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Navbar from './components/Navbar/Navbar';
import ContactButton from './components/ContactButton/ContactButton';
import Home from './pages/Home/Home';
import PricingPage from './pages/Pricing/PricingPage';
import SetupDownloadPage from './pages/SetupDownload/SetupDownloadPage';
import MaualLayout from './components/manual/MaualLayout';
import MaualEmbedPage from './components/manual/MaualEmbedPage';
import AdminLayout from './components/myroom/AdminLayout';
import OpenSatus_users from './components/admin/openSatus_users/OpenSatus_users';
import LoginHistory from './components/admin/loginHistory/LoginHistory';
import SmsSend from './components/admin/sms/SmsSend';
import CouponManage from './components/admin/coupon/CouponManage';
import Ad_login from './components/admin/Ad_login';
import Login from './components/login/Login';
import SignUp from './components/login/SignUp';
import TermsOfService from './components/login/TermsOfService';
import PrivacyPolicy from './components/login/PrivacyPolicy';
import FindId from './components/login/FindId';
import FindPassword from './components/login/FindPassword';
import MyAccount from './components/login/MyAccount';
import TossSuccess from './components/Toss/TossSuccess';
import TossFail from './components/Toss/TossFail';
import Charge from './components/Toss/Charge';
import RefundPolicy from './components/Toss/RefundPolicy';

// 관리자 페이지 컴포넌트 (추후 추가)
const PlaceholderPage = ({ title }) => (
  <div style={{ padding: '2rem' }}><h2>{title}</h2></div>
);

// 관리자 전용 보호 라우트
const AdminRoute = ({ children }) => {
  const isLoggedIn = useSelector((state) => state.appReducer.isLoggedIn);
  const isAdmin = useSelector((state) => state.appReducer.isAdmin);
  if (!isLoggedIn || !isAdmin) {
    return <Navigate to="/" replace />;
  }
  return children;
};

// 로그인 사용자 전용 보호 라우트
const PrivateRoute = ({ children }) => {
  const isLoggedIn = useSelector((state) => state.appReducer.isLoggedIn);
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  const location = useLocation();
  const isManualEmbedRoute = location.pathname.startsWith('/manual/embed/');
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <div className="app">
      {!isManualEmbedRoute && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/setup-download" element={<SetupDownloadPage />} />
        <Route path="/manual" element={<MaualLayout />} />
        <Route path="/manual/embed/:unit2Code" element={<MaualEmbedPage />} />
        <Route path="/admin_mathtailer" element={<Ad_login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/find-id" element={<FindId />} />
        <Route path="/find-password" element={<FindPassword />} />
        <Route path="/toss/success" element={<TossSuccess />} />
        <Route path="/toss/fail" element={<TossFail />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/charge" element={<PrivateRoute><Charge /></PrivateRoute>} />
        <Route path="/myaccount" element={
          <PrivateRoute><MyAccount /></PrivateRoute>
        } />

        {/* 관리자 레이아웃 - 사이드바 유지 */}
        <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
          <Route path="myroom" element={<Navigate to="/admin/users" replace />} />
          <Route path="users" element={<OpenSatus_users />} />
          <Route path="login-history" element={<LoginHistory />} />
          <Route path="sms" element={<SmsSend />} />
          <Route path="coupon" element={<CouponManage />} />
        </Route>
      </Routes>
      {!isManualEmbedRoute && !isAdminRoute && <ContactButton />}
    </div>
  );
}

export default App;

